import React from 'react';
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import ProfilePic from './ProfilePic';
import CustomLink from '../../CustomLink/CustomLink';
import { Route } from '../../../types/types';
import { matchPath, useLocation } from 'react-router-dom';
import { Global } from '../../../../utils/global';

interface Props {
  routes: Route[];
}

const DrawerContent = ({ routes }: Props) => {
  const { pathname } = useLocation();

  const isActiveLink = (rootPath: string) => {
    const match = matchPath(`/${rootPath}/*`, pathname);
    return match !== null;
  };

  return (
    <div>
      <Box sx={{ mt: 2 }}>
        <ProfilePic />
      </Box>
      <Divider />
      <List>
        {routes.map((route) => (
          <CustomLink key={route.name} to={route.link} style={{ textDecoration: 'none' }}>
            <ListItem
              key={route.name}
              sx={{
                color: '#FFFFFF',
                textDecoration: 'none',
                backgroundColor: isActiveLink(route.name) ? Global.COLOR_SECONDARY_BLUE : 'inherit'
              }}
              disablePadding
            >
              <ListItemButton>
                <ListItemIcon sx={{ color: '#FFFFFF' }}>{route.icon ?? <CheckIcon />}</ListItemIcon>
                <ListItemText primary={route.name} />
              </ListItemButton>
            </ListItem>
          </CustomLink>
        ))}
      </List>
    </div>
  );
};

export default DrawerContent;
